const toggleEventsAsideFilterMap = {
	el: {
		asideFilterMapContainer: document.querySelector('.aside-filter-map'),
		toggleButton: document.querySelector('.js-aside-filter-toggle')
	},

	vars: {
		extraLargeAndUp: window.matchMedia('(min-width: 75em)')
	},

	fxHandleToggleAsideFilter(el) {
		// check if element exists
		if (!el) return

		// prevent page reload
		el.preventDefault()

		// toggle aside filter
		this.el.asideFilterMapContainer.classList.toggle('aside-filter--hidden')
	},

	fxWatchModalOnResize() {
		// Condition that make sure when user is resizing the screen the page will not be locked with scroll hidden
		if (!this.vars.extraLargeAndUp.matches && this.el.asideFilterMapContainer.classList.contains('aside-filter--hidden')) {
			this.el.asideFilterMapContainer.classList.remove('aside-filter--hidden')
		}
	},

	events() {
		// check if there is the container
		if (!this.el.asideFilterMapContainer) return

		// Responsible for Toggle Aside Filter 
		this.el.toggleButton.addEventListener('click', el => this.fxHandleToggleAsideFilter(el))

		// resize event for window - Responsible for check if the modal is active and if it is, then it will remove the active class
		window.addEventListener('resize', () => this.fxWatchModalOnResize())
	},

	init() {
		this.events()
	}
}

toggleEventsAsideFilterMap.init()